import { createActionGroup, emptyProps, props } from '@ngrx/store';
import type { PageWarranty } from '../../api/api-types';

export const actions = createActionGroup({
    source: 'WarrantyContent',
    events: {
        'Load Page Warranty': emptyProps(),
        'Load Page Warranty Success': props<{ content: PageWarranty }>(),
        'Load Page Warranty Failure': props<{ error: string }>(),
    },
});
